// import React, { useState, useEffect } from "react";
// import "tailwindcss/tailwind.css";
// import {
//   Table,
//   Button,
//   ActionIcon,
//   Badge,
//   Modal,
//   Textarea
// } from "@mantine/core";
// import {
//   Edit,
//   Ban,
//   Check,
//   PlayerPause,
//   PlayerPlay,
//   Send,
//   Minus
// } from "tabler-icons-react";
// import { DatePicker } from "@mantine/dates";
// import { showNotification } from '@mantine/notifications';
// import AddActionModal from "../../components/Recovery/AddActionModal";
// import {
//   getAllActions,
//   disableAction,
//   pauseUnpauseAction,
//   executeSpecificAction
// } from "../../utilities/apis/recovery";
// import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
// import { formatDate } from "../../utilities/utilities";

// function ActionsPage({ recoveryId, dueDetailId, isViewPage, haveActionRight = true }) {
//   const [actionFormState, setActionFormState] = useState({
//     isModalOpen: false,
//     isEdit: false,
//     actionList: [],
//     id: "",
//     executionDate: "",
//     preferrence: "",
//     emailTemplateId: null,
//     emailTemplate: null,
//     emailTemplateContent: {},
//     emailTemplateHTML: "",
//     noticeTemplateId: null,
//     noticeTemplate: null,
//     noticeTemplateContent: {},
//     fromEmail: "",
//     recoveryId,
//     toEmail: [],
//     ccEmail: [],
//     attachments: [],
//     errors: {},
//   });
//   const fetchActions = async () => {
//     const response = await apiWrapWithErrorWithData(
//       getAllActions({ recoveryId })
//     );
//     if (response.success) {
//       console.log('this is action list ------->>',response.actionList);
//       setActionFormState((prevState) => ({
//         ...prevState,
//         actionList: response.actionList,
//       }));
//     }
//   };
//   useEffect(() => {
//     fetchActions();
//   }, [recoveryId]);
//   const handleEditAction = (row) => {
//     setActionFormState((prevState) => ({
//       ...prevState,
//       isModalOpen: true,
//       isEdit: true,
//       id: row.id,
//       executionDate: new Date(row.executionDate),
//       preferrence: row.preferrence,
//       emailTemplateId: row.emailTemplateId,
//       emailTemplate: row.emailTemplate,
//       emailTemplateContent: row.emailTemplateContent,
//       noticeTemplateId: row.noticeTemplateId,
//       noticeTemplate: row.noticeTemplate,
//       noticeTemplateContent: row.noticeTemplateContent,
//       fromEmail: row.fromEmail,
//       toEmail: row.toEmail,
//       ccEmail: row.ccEmail,
//       attachments: row.attachments,
//     }));
//   };
//   const handleDisableAction = async (id) => {
//     const response = await apiWrapWithErrorWithData(disableAction({ id }));
//     if (response.success) {
//       fetchActions();
//     }
//   };
//   const [actionAuditData, setActionAuditData] = useState({
//     isModalOpen: false,
//     actionId: 0,
//     remark: "",
//     isPaused: false,
//     executionDate: null
//   });
//   const handleActionAuditSubmit = async () => {
//     const response = await apiWrapWithErrorWithData(
//       pauseUnpauseAction({
//         id: actionAuditData.actionId,
//         remark: actionAuditData.remark,
//         isPaused: actionAuditData.isPaused,
//         executionDate: actionAuditData.executionDate
//       })
//     );
//     if (response.success) {
//       fetchActions();
//       setActionAuditData((prevState) => ({
//         ...prevState,
//         isModalOpen: false,
//         actionId: 0,
//         remark: "",
//       }));
//     }
//   };
//   const handleSpecificActionExecution = async (data) => {
//     if (!data.isExecuted && ((data.preferrence === "email" && data.isEmailLocked) || (data.preferrence === "notice" && data.isNoticeLocked && data.isEmailLocked))) {
//       const response = await apiWrapWithErrorWithData(
//         executeSpecificAction({
//           actionId: data.id
//         })
//       );
//       if (response.success) {
//         fetchActions();
//         showNotification({
//           color: 'green',
//           title: 'Email Sent',
//           message: 'Action has been executed successfully.',
//         });
//       }
//     } else {
//       showNotification({
//         color: 'red',
//         title: 'Template is not locked',
//         message: 'If locked then try refreshing the page.',
//       });
//     }
//   }
//   return (
//     <>
//       <AddActionModal
//         formState={actionFormState}
//         setFormState={setActionFormState}
//         errors={actionFormState.errors}
//         fetchActions={fetchActions}
//         dueDetailId={dueDetailId}
//       />
//       <Modal
//         overflow="inside"
//         closeOnClickOutside={false}
//         size="calc(50vw)"
//         opened={actionAuditData.isModalOpen}
//         onClose={() =>
//           setActionAuditData((prevState) => ({
//             ...prevState,
//             isModalOpen: false,
//             actionId: 0,
//             remark: "",
//           }))
//         }
//         title="action audit"
//       >
//         {!actionAuditData.isPaused && (
//           <DatePicker
//             required
//             className="mb-2 max-w-[350px]"
//             placeholder="pick date"
//             label="confirm execution date"
//             openDropdownOnClear={true}
//             value={actionAuditData.executionDate}
//             onChange={(value) =>
//               setActionAuditData((prevState) => ({
//                 ...prevState,
//                 executionDate: value,
//               }))
//             }
//             clearable
//           />
//         )}
//         <Textarea
//           minRows={6}
//           required
//           label="remark"
//           placeholder="type your remark to pause and unpause the action..."
//           value={actionAuditData.remark}
//           onChange={(event) =>
//             setActionAuditData((prevState) => ({
//               ...prevState,
//               remark: event.target.value,
//             }))
//           }
//         />
//         <div className="flex justify-center mt-8">
//           <Button color="green" onClick={handleActionAuditSubmit}>
//             submit
//           </Button>
//         </div>
//       </Modal>
//       {actionFormState.actionList.length !== 0 && (
//         <Table striped highlightOnHover={true} className="mt-4">
//           <thead>
//             <tr>
//               <th>reference no.</th>
//               <th>execution date</th>
//               <th>preference</th>
//               <th>email template</th>
//               <th>notice template</th>
//               <th>from email</th>
//               <th>recipient</th>
//               <th>attachment</th>
//               <th>action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {actionFormState.actionList.map((row) => (
//               <tr
//                 key={row.id}
//                 className={row.isPaused ? "opacity-50 cursor-not-allowed" : ""}
//               >
//                 <td>{`action-${row.id}`}</td>
//                 <td>{formatDate(row.executionDate)}</td>
//                 <td>{row.preferrence}</td>
//                 <td>{row.emailTemplate}</td>
//                 <td>{row.noticeTemplate}</td>
//                 <td>{row.fromEmail}</td>
//                 <td>
//                   <div className="grid grid-cols-12 items-center">
//                     <span className="col-span-2
//                     ">To:</span>
//                     <div className="col-span-10 flex flex-wrap max-w-xs truncate">
//                       {row.toEmail.map((email, index) => (
//                         <Badge
//                           key={index}
//                           className="text-s m-[4px] lowercase max-w-[100px] truncate"
//                           title={email}
//                         >
//                           {email}
//                         </Badge>
//                       ))}
//                     </div>
//                   </div>
//                   <div className="grid grid-cols-12 items-center">
//                     <span className="col-span-2">cc:</span>
//                     <div className="col-span-10 flex flex-wrap max-w-xs truncate">
//                       {row.ccEmail.map((email, index) => (
//                         <Badge
//                           key={index}
//                           className="text-s m-[4px] lowercase max-w-[100px] truncate"
//                           title={email}
//                         >
//                           {email}
//                         </Badge>
//                       ))}
//                     </div>
//                   </div>
//                 </td>
//                 <td className="text-center">{row.attachments.length}</td>
//                 <td>
//                   {!haveActionRight ? (
//                     <div className="grid grid-cols-1">
//                       <ActionIcon>
//                         <Minus color="red" />
//                       </ActionIcon>
//                     </div>
//                   ) :
//                     !isViewPage && !row.isExecuted ? (
//                       <div className="grid grid-cols-2 gap-2">
//                         <ActionIcon
//                           color="blue"
//                           title="Edit"
//                           onClick={() => handleEditAction(row)}
//                         >
//                           <Edit />
//                         </ActionIcon>
//                         <ActionIcon
//                           color="red"
//                           title="Disable"
//                           onClick={() => handleDisableAction(row.id)}
//                         >
//                           <Ban />
//                         </ActionIcon>
//                       </div>
//                     ) : row.isExecuted ? (
//                       <div className="grid grid-cols-1">
//                         <ActionIcon title="Executed">
//                           <Check color="green" />
//                         </ActionIcon>
//                       </div>
//                     ) : (
//                       <div
//                         className={`grid ${row.showSendButton ? "grid-cols-2 gap-2" : "grid-cols-1"}`}
//                       >
//                         {row.isPaused ? (
//                           <ActionIcon
//                             title="Unpause"
//                             onClick={() =>
//                               setActionAuditData((prevState) => ({
//                                 ...prevState,
//                                 isModalOpen: true,
//                                 actionId: row.id,
//                                 isPaused: false,
//                                 executionDate: new Date(row.executionDate)
//                               }))
//                             }
//                           >
//                             <PlayerPlay color="red" />
//                           </ActionIcon>
//                         ) : (
//                           <ActionIcon
//                             title="Pause"
//                             onClick={() =>
//                               setActionAuditData((prevState) => ({
//                                 ...prevState,
//                                 isModalOpen: true,
//                                 actionId: row.id,
//                                 isPaused: true,
//                                 executionDate: new Date(row.executionDate)
//                               }))
//                             }
//                           >
//                             <PlayerPause color="#6c757d" />
//                           </ActionIcon>
//                         )}
//                         {row.showSendButton && (
//                           <ActionIcon title="Send"
//                             onClick={() => handleSpecificActionExecution(row)}
//                           >
//                             <Send color="red" />
//                           </ActionIcon>
//                         )}
//                       </div>
//                     )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       )}
//       {!isViewPage && (
//         <div className="flex justify-center mt-8">
//           <Button
//             color="green"
//             onClick={() =>
//               setActionFormState((prevState) => ({
//                 ...prevState,
//                 isModalOpen: true,
//               }))
//             }
//           >
//             add action
//           </Button>
//         </div>
//       )}
//     </>
//   );
// }

// export default ActionsPage;


import React, { useState, useEffect } from "react";
import "tailwindcss/tailwind.css";
import {
  Table,
  Button,
  ActionIcon,
  Badge,
  Modal,
  Textarea,
  Text
} from "@mantine/core";
import {
  Edit,
  Ban,
  Check,
  PlayerPause,
  PlayerPlay,
  Send,
  Minus
} from "tabler-icons-react";
import { DatePicker } from "@mantine/dates";
import { showNotification } from '@mantine/notifications';
import AddActionModal from "../../components/Recovery/AddActionModal";
import {
  getAllActions,
  disableAction,
  pauseUnpauseAction,
  executeSpecificAction
} from "../../utilities/apis/recovery";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { formatDate } from "../../utilities/utilities";

function ActionsPage({ recoveryId, dueDetailId, isViewPage, haveActionRight = true }) {
  const [actionFormState, setActionFormState] = useState({
    isModalOpen: false,
    isEdit: false,
    actionList: [],
    id: "",
    executionDate: "",
    preferrence: "",
    emailTemplateId: null,
    emailTemplate: null,
    emailTemplateContent: {},
    emailTemplateHTML: "",
    noticeTemplateId: null,
    noticeTemplate: null,
    noticeTemplateContent: {},
    fromEmail: "",
    recoveryId,
    toEmail: [],
    ccEmail: [],
    attachments: [],
    errors: {},
  });
  const fetchActions = async () => {
    const response = await apiWrapWithErrorWithData(
      getAllActions({ recoveryId })
    );
    if (response.success) {
      console.log('this is action list ------->>',response.actionList);
      setActionFormState((prevState) => ({
        ...prevState,
        actionList: response.actionList,
      }));
    }
  };
  useEffect(() => {
    fetchActions();
  }, [recoveryId]);
  const handleEditAction = (row) => {
    setActionFormState((prevState) => ({
      ...prevState,
      isModalOpen: true,
      isEdit: true,
      id: row.id,
      executionDate: new Date(row.executionDate),
      preferrence: row.preferrence,
      emailTemplateId: row.emailTemplateId,
      emailTemplate: row.emailTemplate,
      emailTemplateContent: row.emailTemplateContent,
      noticeTemplateId: row.noticeTemplateId,
      noticeTemplate: row.noticeTemplate,
      noticeTemplateContent: row.noticeTemplateContent,
      fromEmail: row.fromEmail,
      toEmail: row.toEmail,
      ccEmail: row.ccEmail,
      attachments: row.attachments,
    }));
  };
  const handleDisableAction = async (id) => {
    const response = await apiWrapWithErrorWithData(disableAction({ id }));
    if (response.success) {
      fetchActions();
    }
  };
  const [actionAuditData, setActionAuditData] = useState({
    isModalOpen: false,
    actionId: 0,
    remark: "",
    isPaused: false,
    executionDate: null
  });
  const handleActionAuditSubmit = async () => {
    const response = await apiWrapWithErrorWithData(
      pauseUnpauseAction({
        id: actionAuditData.actionId,
        remark: actionAuditData.remark,
        isPaused: actionAuditData.isPaused,
        executionDate: actionAuditData.executionDate
      })
    );
    if (response.success) {
      fetchActions();
      setActionAuditData((prevState) => ({
        ...prevState,
        isModalOpen: false,
        actionId: 0,
        remark: "",
      }));
    }
  };
  const handleSpecificActionExecution = async (data) => {
    if (!data.isExecuted && ((data.preferrence === "email" && data.isEmailLocked) || (data.preferrence === "notice" && data.isNoticeLocked && data.isEmailLocked))) {
      const response = await apiWrapWithErrorWithData(
        executeSpecificAction({
          actionId: data.id
        })
      );
      if (response.success) {
        fetchActions();
        showNotification({
          color: 'green',
          title: 'Email Sent',
          message: 'Action has been executed successfully.',
        });
      }
    } else {
      showNotification({
        color: 'red',
        title: 'Template is not locked',
        message: 'If locked then try refreshing the page.',
      });
    }
  };

  // Header styling definition matching the template
 const headerStyle = (align = 'left', width = 'auto') => ({
    color: '#64748b', // Slate 500
    fontSize: '12px', 
    fontWeight: 600, 
    textTransform: 'uppercase', 
    letterSpacing: '0.05em',
    textAlign: align,
    width: width,
    minWidth: width !== 'auto' ? width : 'auto',
    paddingTop: '16px',
    paddingBottom: '16px',
    borderBottom: '1px solid #e2e8f0'
  });

  // Body cell styling definition matching the template
  const cellStyle = (align = 'left') => ({
    textAlign: align,
    paddingTop: '14px',
    paddingBottom: '14px'
  });

  return (
    <>
      <AddActionModal
        formState={actionFormState}
        setFormState={setActionFormState}
        errors={actionFormState.errors}
        fetchActions={fetchActions}
        dueDetailId={dueDetailId}
      />
      <Modal
        overflow="inside"
        closeOnClickOutside={false}
        size="calc(50vw)"
        opened={actionAuditData.isModalOpen}
        onClose={() =>
          setActionAuditData((prevState) => ({
            ...prevState,
            isModalOpen: false,
            actionId: 0,
            remark: "",
          }))
        }
        title="action audit"
      >
        {!actionAuditData.isPaused && (
          <DatePicker
            required
            className="mb-2 max-w-[350px]"
            placeholder="pick date"
            label="confirm execution date"
            openDropdownOnClear={true}
            value={actionAuditData.executionDate}
            onChange={(value) =>
              setActionAuditData((prevState) => ({
                ...prevState,
                executionDate: value,
              }))
            }
            clearable
          />
        )}
        <Textarea
          minRows={6}
          required
          label="remark"
          placeholder="type your remark to pause and unpause the action..."
          value={actionAuditData.remark}
          onChange={(event) =>
            setActionAuditData((prevState) => ({
              ...prevState,
              remark: event.target.value,
            }))
          }
        />
        <div className="flex justify-center mt-8">
          <Button onClick={handleActionAuditSubmit}>
            submit
          </Button>
        </div>
      </Modal>

      {actionFormState.actionList.length !== 0 && (
        <div className="mt-4 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm ring-1 ring-black ring-opacity-5">
          <div className="overflow-x-auto">
            <Table 
              verticalSpacing="sm" 
              horizontalSpacing="lg" 
              highlightOnHover={true} 
              className="min-w-full divide-y divide-slate-200"
            >
              <thead className="bg-slate-50/80 backdrop-blur-sm sticky top-0 z-10">
                <tr>
                  <th style={headerStyle('left', '80px')}>reference no.</th>
                  <th style={headerStyle('left', '80px')}>execution date</th>
                  <th style={headerStyle('left', '80px')}>preference</th>
                  <th style={headerStyle('left', '160px')}>email template</th>
                  <th style={headerStyle('left', '80px')}>notice template</th>
                  <th style={headerStyle('left', '120px')}>from email</th>
                  <th style={headerStyle('left', '160px')}>recipient</th>
                  <th style={headerStyle('center', '60px')}>attachment</th>
                  <th style={headerStyle('center', '60px')}>action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white">
                {actionFormState.actionList.map((row) => (
                  <tr
                    key={row.id}
                    className={`group transition-all duration-200 hover:bg-blue-50/30 ${row.isPaused ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    <td style={cellStyle('left')} className="whitespace-nowrap">
                      <Text size="sm" weight={500} className="text-slate-700">
                        {`action-${row.id}`}
                      </Text>
                    </td>
                    <td style={cellStyle('left')} className="whitespace-nowrap">
                      <Text size="sm" weight={500} className="text-slate-700">
                        {formatDate(row.executionDate)}
                      </Text>
                    </td>
                    <td style={cellStyle('left')} className="whitespace-nowrap">
                      <Text size="sm" weight={500} className="text-slate-700">
                        {row.preferrence}
                      </Text>
                    </td>
                    <td style={cellStyle('left')} className="whitespace-nowrap">
                      <Text size="sm" weight={500} className="text-slate-700">
                        {row.emailTemplate}
                      </Text>
                    </td>
                    <td style={cellStyle('left')} className="whitespace-nowrap">
                      <Text size="sm" weight={500} className="text-slate-700">
                        {row.noticeTemplate}
                      </Text>
                    </td>
                    <td style={cellStyle('left')} className="whitespace-nowrap">
                      <Text size="sm" weight={500} className="text-slate-700">
                        {row.fromEmail}
                      </Text>
                    </td>
                    <td style={cellStyle('left')} className="whitespace-nowrap">
                      <div className="grid grid-cols-12 items-center">
                        <span className="col-span-2 text-xs font-semibold text-slate-400 uppercase">To:</span>
                        <div className="col-span-10 flex flex-wrap max-w-xs truncate">
                          {row.toEmail.map((email, index) => (
                            <Badge
                              key={index}
                              className="text-s m-[4px] lowercase max-w-[100px] truncate"
                              title={email}
                            >
                              {email}
                            </Badge>
                          ))}
                        </div>
                      </div>
                      <div className="grid grid-cols-12 items-center mt-1">
                        <span className="col-span-2 text-xs font-semibold text-slate-400 uppercase">cc:</span>
                        <div className="col-span-10 flex flex-wrap max-w-xs truncate">
                          {row.ccEmail.map((email, index) => (
                            <Badge
                              key={index}
                              className="text-s m-[4px] lowercase max-w-[100px] truncate"
                              title={email}
                            >
                              {email}
                            </Badge>
                          ))}
                        </div>
                      </div>
                    </td>
                    <td style={cellStyle('center')} className="whitespace-nowrap">
                      <Text size="sm" weight={500} className="text-slate-700">
                        {row.attachments.length}
                      </Text>
                    </td>
                    <td style={cellStyle('center')} className="whitespace-nowrap">
                      <div className="flex items-center justify-center">
                        {!haveActionRight ? (
                          <div className="grid grid-cols-1">
                            <ActionIcon variant="subtle">
                              <Minus  />
                            </ActionIcon>
                          </div>
                        ) :
                          !isViewPage && !row.isExecuted ? (
                            <div className="flex items-center gap-2">
                              <ActionIcon
                                // color="blue"
                                title="Edit"
                                onClick={() => handleEditAction(row)}
                                variant="subtle"
                              >
                                <Edit size={18} />
                              </ActionIcon>
                              <ActionIcon
                                // color="red"
                                title="Disable"
                                onClick={() => handleDisableAction(row.id)}
                                variant="subtle"
                              >
                                <Ban size={18} />
                              </ActionIcon>
                            </div>
                          ) : row.isExecuted ? (
                            <div className="grid grid-cols-1">
                              <ActionIcon title="Executed" variant="subtle">
                                <Check color="green" size={18} />
                              </ActionIcon>
                            </div>
                          ) : (
                            <div
                              className={`flex items-center gap-2`}
                            >
                              {row.isPaused ? (
                                <ActionIcon
                                  title="Unpause"
                                  variant="subtle"
                                  onClick={() =>
                                    setActionAuditData((prevState) => ({
                                      ...prevState,
                                      isModalOpen: true,
                                      actionId: row.id,
                                      isPaused: false,
                                      executionDate: new Date(row.executionDate)
                                    }))
                                  }
                                >
                                  <PlayerPlay color="red" size={18} />
                                </ActionIcon>
                              ) : (
                                <ActionIcon
                                  title="Pause"
                                  variant="subtle"
                                  onClick={() =>
                                    setActionAuditData((prevState) => ({
                                      ...prevState,
                                      isModalOpen: true,
                                      actionId: row.id,
                                      isPaused: true,
                                      executionDate: new Date(row.executionDate)
                                    }))
                                  }
                                >
                                  <PlayerPause color="#6c757d" size={18} />
                                </ActionIcon>
                              )}
                              {row.showSendButton && (
                                <ActionIcon title="Send"
                                  variant="subtle"
                                  onClick={() => handleSpecificActionExecution(row)}
                                >
                                  <Send size={18} />
                                </ActionIcon>
                              )}
                            </div>
                          )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
      {!isViewPage && (
        <div className="flex justify-center mt-8">
          <Button
            // color="green"
            onClick={() =>
              setActionFormState((prevState) => ({
                ...prevState,
                isModalOpen: true,
              }))
            }
          >
            add action
          </Button>
        </div>
      )}
    </>
  );
}

export default ActionsPage;